import { formatDate } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { MatPaginator, MatTable, MatTableDataSource } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { ConcessionarioPessoa } from '@tivic-team/manager-ts/dist/mob/entities/concessao/concessionario-pessoa.entity';
import { ConcessionarioPessoaStatusLabels } from '@tivic-team/manager-ts/dist/mob/enums/concessionario-pessoa/concessionario-pessoa-status';
import { ConcessionarioPessoaTipoVinculo } from '@tivic-team/manager-ts/dist/mob/enums/concessionario-pessoa/concessionario-pessoa-tipo-vinculo';
import { ConcessionarioPessoaDTO } from 'app/model/dtos/mob/concessionario-pessoa.dto';
import { ConcessionarioPessoaSearch } from 'app/services/mob/concessionario-pessoa.search';
import { ConcessionarioPessoaService } from 'app/services/mob/concessionario-pessoa.service';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'grid-motorista-auxiliar',
  templateUrl: './grid-motorista-auxiliar.component.html',
  styleUrls: ['./grid-motorista-auxiliar.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class GridMotoristaAuxiliarComponent implements OnInit, AfterViewInit {

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatTable, { static: true }) dataTable: MatTable<ConcessionarioPessoaDTO>;

  @Output() onFind: EventEmitter<ConcessionarioPessoa> = new EventEmitter();

  dataSource: MatTableDataSource<ConcessionarioPessoaDTO> = new MatTableDataSource<ConcessionarioPessoaDTO>();
  displayedColumns: string[] = ['nome', 'endereco', 'dtAtivacao', 'dtInativacao', 'validadeCnh', 'stConcessionarioPessoa'];
  formGroup: FormGroup;
  cdConcessao: number;
  paginatorLength: number = 0;
  pageIndex: number = 0;
  pageSize: number = 10;

  constructor(
    private _concessionarioPessoaService: ConcessionarioPessoaService,
    private _controlContainer: ControlContainer,
    private _activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.formGroup = this._controlContainer.control as FormGroup;
    this.cdConcessao = +this._activatedRoute.snapshot.params["cdConcessao"];
  }

  ngAfterViewInit() {
    this.load(0);
  }

  _onPageChange(val) {
    this.pageIndex = val.pageIndex;
    this.load(this.pageIndex + 1)
  }

  async load(page: number) {
    try {
      if (this.cdConcessao > 0) {
        let filter = new ConcessionarioPessoaSearch({
          tpVinculo: ConcessionarioPessoaTipoVinculo.AUXILIAR,
          cdConcessao: this.cdConcessao,
          limit: this.pageSize,
          page: page
        });
        this._concessionarioPessoaService.findConcessionarioPessoa(filter).then(result => {
          this.paginatorLength = result.total;
          this.dataSource = new MatTableDataSource(result.items);
        });
      }
    }
    catch (error) {
      console.error('error = ', error)
    }
  }

  enderecoLabelFunction(colunm, register: ConcessionarioPessoaDTO) {
    if (register &&
        register.pessoaEndereco.nmLogradouro && 
        register.pessoaEndereco.nmBairro && 
        register.pessoaEndereco.nrEndereco != undefined) 
        return `${register.pessoaEndereco.nmLogradouro}, ${register.pessoaEndereco.nmBairro}, ${register.pessoaEndereco.nrEndereco}`;

    return 'Não Informado';
  }

  dateAtivacaoLabelFunction(colunm, register: ConcessionarioPessoaDTO){
    if(register  && register.dtAtivacao){
       let date = formatDate(register.dtAtivacao , 'dd/MM/yyyy', 'pt-BR'); 
       return date;
    }
    return 'Não Informado';
  }

  dateInativacaoLabelFunction(colunm, register: ConcessionarioPessoaDTO){
    if(register && register.dtInativacao){
       let date = formatDate(register.dtInativacao , 'dd/MM/yyyy', 'pt-BR'); 
       return date;
    }
    return 'Não Informado';
  }

  dateValidadeCnhLabelFunction(colunm, register: ConcessionarioPessoaDTO){
    if(register && register.pessoaFisica && register.pessoaFisica.dtValidadeCnh){
       let date = formatDate(register.pessoaFisica.dtValidadeCnh, 'dd/MM/yyyy', 'pt-BR'); 
       return date;
    }
    return 'Não Informado';
  }

  getStConcessionarioPessoaFunction(column, register: ConcessionarioPessoaDTO) {
    if (register.stConcessionarioPessoa != undefined) 
      return ConcessionarioPessoaStatusLabels.get(register.stConcessionarioPessoa);
    
    return 'Não Informado';
  }
}